export const SHEET = { columns: 6, rows: 5 };

export const VERTEX = `attribute vec2 p;varying vec2 uv;void main(){uv=p*.5+.5;gl_Position=vec4(p,0.,1.);}`;

// Live thermal texture. R: signed distance; G: original alpha.
export const FRAGMENT = `precision highp float;
varying vec2 uv;uniform sampler2D matte;uniform vec2 cell;uniform float time;uniform bool reducedMotion;
float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}
float noise(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(hash(i),hash(i+vec2(1,0)),f.x),mix(hash(i+vec2(0,1)),hash(i+vec2(1,1)),f.x),f.y);}
void main(){
 vec2 v=vec2(uv.x,1.-uv.y);
 vec4 data=texture2D(matte,(cell+v)/vec2(${SHEET.columns}.,${SHEET.rows}.));
 if(reducedMotion){gl_FragColor=vec4(vec3(data.g),data.g);return;}
 float d=(data.r*255.-128.)/8.;
 // Animated density fields change local thickness without displacing the lettering.
 float cloud=noise(v*6.+vec2(time*.394875,-time*.212625));
 float detail=noise(v*24.+vec2(-time*.22275,time*.313875));
 float heat=.7*cloud+.3*detail;
 float spread=-1.2+9.2*smoothstep(.18,.78,heat);
 float edge=d+spread;
 float body=smoothstep(-1.2,1.2,edge);
 // A narrow, layered thermal rim and soft diffusion around the original contour.
 float rim=exp(-pow((edge-2.4)/1.5,2.));
 float inner=exp(-pow((edge-5.8)/1.7,2.));
 float density=.44+.56*heat-.58*rim+.28*inner;
 float grain=(noise(v*230.)-.5)*.14;
 float halo=exp(-max(-edge,0.)*.43)*.34*(1.-body);
 float alpha=clamp(body*(density+grain)+halo,0.,1.);
 gl_FragColor=vec4(vec3(alpha),alpha);
}`;
